
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ShareableItemType, shareUrlsByType } from 'globals/store/share.data';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'copy-url',
    template: `
<div class="secondary_link"  style="font-size: 14px;" (click)="copyTextToClipboard(fullUrl || (baseUrl + url + shareCode), $event)">
  <span *ngIf="!justClicked">Copy URL</span><span class="just-clicked" *ngIf="justClicked">Copied!</span> <icon style="font-size: 12px !important; width: 12px !important; height: inherit;" icon="link12"></icon>
</div>
`,
    styles: [`
span { width: 64px; display: inline-block; text-align: center; }
span.just-clicked { font-weight: bold; }
icon {  width: 22px; margin-left: 4px; line-height: 14px; }
`],
    standalone: true,
    imports: [CommonModule, IconComponent],
})

export class CopyUrlComponent implements OnInit {
  baseUrl = environment.joi.shareBase
  functionsUrl = environment['isLocal'] ? environment.functionsURL + 'func/' : environment.joi.shareBase
  @Input() fullUrl = ''
  url
  @Input() shareType: ShareableItemType
  @Input() shareCode
  justClicked = false;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    this.url = shareUrlsByType[this.shareType] + '/'
  }

  copyTextToClipboard(text: string, event: any = null) {
    if (event) {
      event.stopPropagation()
    }
    navigator['clipboard'].writeText(text);
    this.justClicked = true;
    setTimeout(()=> this.justClicked = false, 3000)
  }

}


